const Settings = {
  revalidate: process.env.VERCEL_ENV === "production" ? 30 : 5,
  isPaperBg: (componentName) =>
    [
      "Home",
      "Fonts",
      "FontsFamily",
      "ShopIndex",
      "ShopProduct",
      "About",
      "Print",
      "PrintTermsAndConditions"
    ].includes(componentName),
  usePaperImage: (componentName) =>
    ["Home",
      "Fonts",
      "FontsFamily",].includes(componentName),
  useRiso: (componentName) =>
    ["Home", "Fonts", "ShopIndex",
      "ShopProduct", "About", "Print", "PrintTermsAndConditions"].includes(componentName),
  paperBgColor: (componentName) => {
    if (["About", "ShopIndex",
      "ShopProduct", "Print", "PrintTermsAndConditions"].includes(componentName)) {
      return "#ffecd8";
    } else {
      return "var(--color-truewhite)";
    }
  },
  paperBgBlendMode: (componentName) =>
    ["About", "ShopIndex",
      "ShopProduct", "Print", "PrintTermsAndConditions"].includes(componentName) ? "multiply" : "",
  useNavBg: (componentName) =>
    !["Home", "About", "FontsFamily", "ShopIndex",
      "ShopProduct", "Print", "PrintTermsAndConditions"].includes(componentName),
};

export default Settings;
